import { useQuery } from '@tanstack/react-query';
import { getAppointmentById, getNonMaterializedAppointment  } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useAppointmentByIdQuery = (appointmentId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'appointment', appointmentId ], async () => {
    const response = await getAppointmentById(appointmentId);

    return response.data;
  }, opts);
};


export type UseAppointmentQueryParams = {
  id: string;
  isMaterialized: true;
} | {
  id: string;
  parentId: string;
  fromDatetime: string;
  isMaterialized: false;
};

export const useAppointmentQuery = (
  params: UseAppointmentQueryParams,
  opts?: BaseQueryOpts
) => {
  return useQuery([ 'appointment', params ], async () => {
    if (params.isMaterialized === true) {
      const response = await getAppointmentById(params.id);

      return response.data;
    } else if (params.isMaterialized === false) {
      const response = await getNonMaterializedAppointment(params.parentId, params.fromDatetime);

      return response.data;
    }

    return null;
  }, opts);
};
